export default "__VITE_ASSET__CD0c8VzH__"